import { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import emailjs from '@emailjs/browser';

const useContact = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const t = translations[language].contact;
    
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [notification, setNotification] = useState({
        show: false,
        message: '',
        type: ''
    });

    // Inicializar EmailJS una vez cuando el componente se monta
    useEffect(() => {
        emailjs.init("Sz2dg-roTNNUxL1p7");
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Función para mostrar notificaciones
    const showNotification = (message, type) => {
        setNotification({
            show: true,
            message,
            type
        });

        // Ocultar la notificación después de 3 segundos
        setTimeout(() => {
            setNotification(prev => ({
                ...prev,
                show: false
            }));
        }, 3000);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        try {
            await emailjs.send(
                'service_0f8ly6r', 
                'template_e69abyk',
                {
                    from_name: formData.name,
                    from_email: formData.email,
                    subject: formData.subject,
                    message: formData.message,
                }
            );
            
            // Muestra mensaje de éxito
            showNotification(t.notifications.success, 'success');
            
            // Limpia el formulario
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
        } catch (error) {
            // Muestra mensaje de error
            showNotification(t.notifications.error, 'error');
            console.error('Error sending email:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        theme,
        t,
        formData,
        isSubmitting,
        notification,
        handleChange,
        handleSubmit
    };
};

export default useContact;